import React from "react";
import { Elements } from '@stripe/react-stripe-js';
import { StripeProvider } from 'react-stripe-elements';
import { Route, Switch, useRouter } from "util/router.js";
import OfferingList from 'components/OfferingList'
import OfferingCheckout from 'components/OfferingCheckout';
import OfferingConfirmation from 'components/OfferingConfirmation';
import { useDispatch } from 'react-redux';
import {useWidget} from 'util/widget'
import { fetchInstructorData } from 'store/actions/widgetActions';

function PricingWidget(props) {
    const { match, stripe } = props;
    const widget = useWidget()
    const dispatch = useDispatch();
    React.useEffect(() => {
        if (widget && widget.widgetName) {
            dispatch(fetchInstructorData(widget.widgetName, "offerings"));
        }
    }, [dispatch, widget.widgetName])
    return (
    <>
        <Switch>
            <Route
                path={`${match.url}/confirm/:platformID`}
                render={props => <OfferingConfirmation {...props}/>}
            />
            <Route
                path={`${match.url}/checkout/:platformID`}
                render={props => (
                    <StripeProvider stripe={stripe} >
                        <Elements stripe={stripe} >
                            <OfferingCheckout {...props}/>
                        </Elements>
                    </StripeProvider>
                )}
            />
            <Route
                path={`${match.url}`}
                component={OfferingList}
            />
        </Switch>
    </>
    )
}

export default PricingWidget;